import { MessageCircle, Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

interface ProductCardProps {
  name: string;
  description?: string;
  category: string;
  image?: string;
  slug: string;
}

const ProductCard = ({ name, description, category, image, slug }: ProductCardProps) => {
  const whatsappUrl = `https://wa.me/${import.meta.env.VITE_WHATSAPP_PHONE}?text=Hola!%20Me%20interesa%20el%20producto:%20${encodeURIComponent(name)}`;

  return (
    <article className="card-luxury rounded-lg overflow-hidden group">
      {/* Image Container */}
      <div className="relative aspect-square overflow-hidden">
        <img
          src={image || 'https://via.placeholder.com/400x400?text=No+Image'}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        {/* Category Badge */}
        <span className="absolute top-4 left-4 px-3 py-1 text-xs font-body uppercase tracking-widest bg-background/90 text-primary border border-border rounded-full">
          {category}
        </span>
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="font-display text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-colors duration-300">
          {name}
        </h3>
        <p className="font-body text-sm text-muted-foreground mb-4 line-clamp-2">
          {description || 'Sin descripción disponible'}
        </p>
        <div className="space-y-2">
          <Button
            variant="elegant"
            size="sm"
            className="w-full"
            asChild
          >
            <Link to={`/producto/${slug}`}>
              <Eye className="mr-2 h-4 w-4" />
              Ver Detalle
            </Link>
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="w-full"
            asChild
          >
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
              <MessageCircle className="mr-2 h-4 w-4" />
              Preguntar
            </a>
          </Button>
        </div>
      </div>
    </article>
  );
};

export default ProductCard;
